import getClassNames from 'classnames';
import React from 'react';
import Icon from '../../Icon/Icon';
import Element, { CommonProps } from '../../Element/Element';
import styles from '../Table.module.scss';
import { sortingOptionType } from '../TableHeaderCell/TableHeaderCell';

type TableSortLabelProps = {
  /** Label will have the active styling (should be true for the sorted column) */
  active?: boolean;
  /** The current sort direction */
  sortDirection?: sortingOptionType;
  /** Hide sort icon */
  hideSortIcon?: boolean;
  ref?: React.Ref<HTMLSpanElement>;
} & Omit<CommonProps<'span'>, 'tagName' | 'ref'>;

const TableSortLabel: React.FunctionComponent<TableSortLabelProps> = React.forwardRef(
  function TableSortLabel(
    {
      active,
      children,
      sortDirection = 'desc',
      hideSortIcon,
      onClick,
      className,
      ...props
    },
    ref?: React.Ref<HTMLSpanElement>
  ) {
    const getIconState = () => {
      if (active) {
        switch (sortDirection) {
          case 'asc':
            return 'chevron-up';
          case 'desc':
            return 'chevron-down';
        }
      }
      return 'sorter';
    };

    const classNames = getClassNames([
      styles.table_sort_label,
      { table_sort_label_active: active },
      className,
    ]);
    return (
      <Element
        tagName="span"
        className={classNames}
        ref={ref}
        onClick={onClick}
        {...props}
      >
        {children}
        {!hideSortIcon && (
          <Icon
            name={getIconState()}
            size="sm"
            color={active ? 'black' : 'gray500'}
          />
        )}
      </Element>
    );
  }
);

export default TableSortLabel;
